import { render, staticRenderFns } from "./comment-list.vue?vue&type=template&id=30b662d0"
import script from "./comment-list.vue?vue&type=script&lang=js"
export * from "./comment-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports